module.exports = __webpack_public_path__ + "static/media/blackjack.netent.3b5f9497.jpeg";